import script from "./recruitApplyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./recruitApplyList.vue?vue&type=script&lang=ts&setup=true"

import "./recruitApplyList.vue?vue&type=style&index=0&id=13a2c7f7&lang=less"

const __exports__ = script;

export default __exports__